import PropTypes from 'prop-types';
import {Component} from 'react';
import {connect} from 'react-redux';
import SelectableContainer from '../../../../UI/SelectableContainer/SelectableContainer';
import {getDeliveryOptions} from '../../../actions/deliveryOptionActions';
import {updateSelectedCollectionPoint} from '../../../actions/pudo-actions';
import {getSelectedPudoAddress} from '../../../selectors/PudoSelectors';
import PudoSavedAddress from './PudoSavedAddress';
import './PudoSavedAddresses.scss';

export class PudoSavedAddresses extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.deliveryType !== 'pudo') return;
    
    const hasChangedPudoAddress = prevProps.selectedCollectionPointAddress !== this.props.selectedCollectionPointAddress;
    
    if (hasChangedPudoAddress) {
      this.props.getDeliveryOptions();
    }
  }
  
  render() {
    return (
      <div className="PudoSavedAddresses">
        {this.props.addresses.map((address, index) => (
          <div className="PudoSavedAddresses__address">
            <SelectableContainer
              componentId={`StoredPudoAddress-${index}`}
              isSelected={index === this.props.selectedCollectionPoint}
            >
              <PudoSavedAddress
                radioInputHidden
                disabled={this.props.disabled}
                checked={this.props.selectedCollectionPoint === index}
                index={index}
                key={index}
                address={address}
                lastIndex={this.props.addresses.length}
                updateSelectedCollectionPoint={this.props.updateSelectedCollectionPoint}
              />
            </SelectableContainer>
          </div>
        ))}
      </div>
    );
  }
}

PudoSavedAddresses.propTypes = {
  addresses: PropTypes.array.isRequired,
  selectedCollectionPoint: PropTypes.number,
  disabled: PropTypes.bool.isRequired,
  selectedCollectionPointAddress: PropTypes.object,
  deliveryType: PropTypes.string.isRequired,
  
  // Actions
  updateSelectedCollectionPoint: PropTypes.func.isRequired,
  getDeliveryOptions: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  addresses: state.pudo.savedAddresses,
  selectedCollectionPoint: parseInt(state.pudo.selectedCollectionPoint),
  selectedCollectionPointAddress: getSelectedPudoAddress(state),
  deliveryType: state.delivery.deliveryType,
});

export default connect(mapStateToProps, {updateSelectedCollectionPoint, getDeliveryOptions})(PudoSavedAddresses);
